import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { DeleteCollection } from '../AppActionTypes';

export interface DeleteCollectionAction extends Action {
  targetItem: IContentInfo;
}

export function deleteCollectionAction(targetItem: IContentInfo): DeleteCollectionAction {
  return {
    type: DeleteCollection,
    targetItem: targetItem
  };
}
